import React from 'react';
import { Nav } from 'react-bootstrap';
import { LockFill } from 'react-bootstrap-icons';

function SectionNavbar ({ section, segments, currentSegment, activeTestType, onSegmentSelect, onTestSelect }) {
    return (
      <Nav
        className="section-navbar flex-column"
      >
      {segments.map((segment, index) => {
        const techniqueSubPages = [
          "Instructions",
          "Cultural and Religious Considerations",
          "Developmental Considerations",
          "Clinical Challenges"
        ];

        const isSubPage = section.slug !== "applying-tf-cbt-to-ctg" && techniqueSubPages.includes(segment.title);
        const isFirstSubPage = segment.title === "Instructions";

        return (
        <React.Fragment key={segment.slug}>
          {index === 1 && (
            <Nav.Item>
              <Nav.Link
                active={activeTestType === 'pre_test'}
                onClick={() => onTestSelect("pre_test", section.id)}
              >
                Pre-Test
              </Nav.Link>
            </Nav.Item>
          )}

          {isFirstSubPage && (
            <Nav.Item>
               <div className="nav-link" style={{ cursor: 'default', pointerEvents: 'none' }}>
                 Technique
               </div>
            </Nav.Item>
          )}

          <Nav.Item>
            <Nav.Link
              className={isSubPage ? "ms-3" : ""}
              active={currentSegment && currentSegment.slug === segment.slug}
              onClick={() => !segment.locked && onSegmentSelect(segment.slug)}
              disabled={segment.locked}
              style={segment.locked ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
            >
              {segment.locked && <LockFill className="me-2" />}
              {segment.title}
            </Nav.Link>
          </Nav.Item>

          {index === segments.length - 1 && (
            <Nav.Item>
              <Nav.Link
                active={activeTestType === 'post_test'}
                onClick={() => !segment.locked && onTestSelect("post_test", section.id)}
                disabled={segment.locked}
                style={segment.locked ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
              >
                {segment.locked && <LockFill className="me-2" />}
                Post-Test
              </Nav.Link>
            </Nav.Item>
          )}
        </React.Fragment>
        );
      })}
      </Nav>
    );
  }

export default SectionNavbar;
